import { useMemo, useState } from "react";
import { usePlatformStore } from "@platform/store";
import {
  useFetchPendingInvitations,
  useClaimPendingInvitation,
  INVITATION_TYPE,
} from "@core/features/invitation";
import { PendingInvitationsList } from "./PendingInvitationsList";

type Props = {
  currentProgramId?: number;
};

export function PendingInvitationsListContainer({ currentProgramId }: Props) {
  const user = usePlatformStore((s) => s.user);
  const [claimingShortcode, setClaimingShortcode] = useState<string | null>(
    null,
  );

  const { data: allInvitations = [] } = useFetchPendingInvitations({ user });
  const { mutateAsync: claimInvitation } = useClaimPendingInvitation();

  const invitations = useMemo(() => {
    if (!currentProgramId) return allInvitations;
    return allInvitations.filter(
      (inv) =>
        !(
          inv.program_id === currentProgramId &&
          (inv.invitation_type === INVITATION_TYPE.PARTICIPANT ||
            inv.invitation_type === INVITATION_TYPE.PARTICIPANT_FRIEND)
        ),
    );
  }, [allInvitations, currentProgramId]);

  const handleClaim = async (shortcode: string) => {
    setClaimingShortcode(shortcode);
    try {
      await claimInvitation({ shortcode });
    } finally {
      setClaimingShortcode(null);
    }
  };

  return (
    <PendingInvitationsList
      invitations={invitations}
      onClaim={handleClaim}
      claimingShortcode={claimingShortcode}
    />
  );
}

export default PendingInvitationsListContainer;
